(() => {
  // app/scripts/product-page.js
  if (window.theme.routes.pageType == "product") {
    if (!customElements.get("pdp-sticky-component")) {
      class productStickyBottomBar extends HTMLElement {
        constructor() {
          super();
          if (theme.routes.pageType != "product" || this.closest("popup-component"))
            return;
          this.mql = window.matchMedia("(min-width: 750px");
          if (!this.mql.matches) {
            this.updateBCPOPosition();
          }
          this.mql.addEventListener("change", (e) => {
            if (e.matches) {
              this.updateBCPOPosition(false);
              this.moveAllChildrenKeepEvents(
                this.querySelector(".best-custom-product-options-arn"),
                document.querySelector("product-form .best-custom-product-options")
              );
            } else {
              this.updateBCPOPosition(true);
              this.moveAllChildrenKeepEvents(
                document.querySelector("product-form .best-custom-product-options"),
                this.querySelector(".best-custom-product-options-arn")
              );
            }
          });
        }
        moveAllChildrenKeepEvents(from, to) {
          while (from.firstChild) {
            to.appendChild(from.firstChild);
          }
        }
        connectedCallback() {
          this.BCPOEventsHandler();
          this.changeReviewWidgetStyles();
          this.stickyHandler();
          this.mql.addEventListener("change", (e) => {
            this.stickyHandler();
          });
          this.resizeHandler = this.resizeHandler.bind(this);
          window.addEventListener("resize", this.resizeHandler);
          this.resizeHandler();
          this.onScroll = this.onScroll.bind(this);
          this.lastScroll = 0;
          this.productForm = document.querySelector("product-container .product-info-detail");
          if (this.getAttribute("data-reveal-element")) {
            const revealElementSelector = this.getAttribute("data-reveal-element");
            this.revealElement = document.querySelector(`${revealElementSelector}`);
          }
          if (this.getAttribute("data-hide-element")) {
            const hideElementSelector = this.getAttribute("data-hide-element");
            this.hideElement = document.querySelector(`${hideElementSelector}`);
          }
          window.addEventListener("scroll", this.onScroll, { passive: true });
          this.onScroll();
        }
        BCPOEventsHandler() {
          const positionHandler = () => {
            const stickyEl = document.querySelector(".pdp-sticky-component-wrapper");
            const stickyHeight = stickyEl.offsetHeight;
            const viewportHeight = window.innerHeight;
            if (stickyHeight >= viewportHeight - 70) {
              stickyEl.style.position = "relative";
            } else {
              stickyEl.style.position = "sticky";
            }
          };
          this.addEventListener("change", positionHandler);
          const waitForBCPO = setInterval(() => {
            if (document.querySelector("#bcpo")) {
              clearInterval(waitForBCPO);
              positionHandler();
            }
          }, 50);
        }
        stickyHandler() {
          if (window.innerWidth >= 750) {
            this.stickyObserver?.disconnect();
            return;
          }
          const stickyEl = document.querySelector(".pdp-sticky-component-wrapper");
          const sentinel = document.querySelector(".pdp-sticky-component-sentinel");
          this.stickyObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                stickyEl.classList.remove("is-sticky");
                document.body.classList.remove("pdp-bottom-bar-is-sticky");
                document.body.classList.add("pdp-bottom-bar-is-reset");
              } else {
                stickyEl.classList.add("is-sticky");
                document.body.classList.add("pdp-bottom-bar-is-sticky");
                document.body.classList.remove("pdp-bottom-bar-is-reset");
              }
            },
            {
              root: null,
              threshold: 0
            }
          );
          this.stickyObserver.observe(sentinel);
        }
        updateBCPOPosition(bool = true) {
          const arnCustom = this.querySelector(".best-custom-product-options-arn");
          arnCustom.classList.toggle("best-custom-product-options", bool);
        }
        changeReviewWidgetStyles() {
          const reviewWidgetHost = this.querySelector(".gw-rv-average-placeholder");
          if (!reviewWidgetHost)
            return;
          const waitForReviewApp = setInterval(() => {
            const shadow = reviewWidgetHost.shadowRoot;
            if (shadow) {
              clearInterval(waitForReviewApp);
              const style = document.createElement("style");
              style.textContent = `
                            @media (max-width: 749px) {
                                .gw-rv-tooltip__tooltip {
                                    top: auto !important;
                                    bottom: 2.2em !important;
                                }
                                .gw-rv-tooltip-arrow {
                                    transform: rotate(180deg) !important;
                                    top: auto !important;
                                    bottom: -5% !important;
                                }
                            }
                        `;
              shadow.appendChild(style);
            }
          }, 100);
        }
        resizeHandler() {
          document.documentElement.style.setProperty("--stickyMobileHeight", this.clientHeight + "px");
        }
        onScroll() {
          if (window.innerWidth >= 750)
            return;
          const currentScroll = window.scrollY;
          if (currentScroll > this.lastScroll) {
            if (this.revealElement && window.getComputedStyle(this.revealElement).display != "none") {
              const revealElementTop = Math.round(this.revealElement.getBoundingClientRect().top + window.scrollY);
              if (currentScroll > revealElementTop) {
                if (this.hideElement) {
                  const hideElementTop = Math.round(this.hideElement.getBoundingClientRect().top + window.scrollY);
                  if (currentScroll > hideElementTop) {
                    document.body.classList.remove("show-simple-sticky");
                  } else {
                    document.body.classList.add("show-simple-sticky");
                  }
                } else {
                  document.body.classList.add("show-simple-sticky");
                }
              }
            }
          } else {
            if (this.revealElement && window.getComputedStyle(this.revealElement).display != "none") {
              const revealElementTop = Math.round(this.revealElement.getBoundingClientRect().top + window.scrollY);
              if (currentScroll < revealElementTop) {
                document.body.classList.remove("show-simple-sticky");
              } else {
                if (this.hideElement) {
                  const hideElementTop = Math.round(this.hideElement.getBoundingClientRect().top + window.scrollY);
                  if (currentScroll < hideElementTop) {
                    document.body.classList.add("show-simple-sticky");
                  }
                }
              }
            }
          }
          this.lastScroll = currentScroll;
        }
        disconnectedCallback() {
          this.priceObserver?.disconnect();
          this.stickyObserver?.disconnect();
          window.removeEventListener("resize", this.resizeHandler);
          window.removeEventListener("scroll", this.onScroll, { passive: true });
        }
      }
      customElements.define("pdp-sticky-component", productStickyBottomBar);
    }
    (function PDPPhotoSwipeEvents() {
      const mainProductSection = document.querySelector(".shopify-section-main-product product-slider-component .main-slider");
      if (!mainProductSection || window.pdpZoomLoaded)
        return;
      const handleClick = (e) => {
        const target = e.target;
        if (window.innerWidth > 750) {
          if (target.closest(".media-type-image")) {
            document.dispatchEvent(
              new CustomEvent("product-zoom:init", {
                detail: {
                  selector: "product-slider-component .main-slider",
                  target: target.closest(".media-type-image").getAttribute("data-media-index")
                }
              })
            );
            mainProductSection.removeEventListener("click", handleClick);
            window.pdpZoomLoaded = true;
          }
        } else {
          if (target.closest(".js-trigger-zoom")) {
            document.dispatchEvent(
              new CustomEvent("product-zoom:init", {
                detail: {
                  selector: "product-slider-component .main-slider",
                  target: target.closest(".media-type-image").getAttribute("data-media-index")
                }
              })
            );
            mainProductSection.removeEventListener("click", handleClick);
            window.pdpZoomLoaded = true;
          }
        }
      };
      mainProductSection.addEventListener("click", handleClick);
    })();
    if (!customElements.get("quick-switch-images")) {
      class QuickSwitchImages extends HTMLElement {
        connectedCallback() {
          if (this.classList.contains("qs-clone"))
            return;
          this.list = this.querySelector(".list-items");
          this.type = this.classList.contains("accordion-quickswitch") ? "quickswitch" : "similar";
          this.resizeHandler = this.resizeHandler.bind(this);
          window.addEventListener("resize", this.resizeHandler);
          this.resizeHandler();
          this.init();
        }
        disconnectedCallback() {
          window.removeEventListener("resize", this.resizeHandler);
        }
        resizeHandler() {
          if (!document.querySelector(`.${this.type}-clone`)) {
            this.clone = this.cloneNode(true);
            this.clone.classList.add(`${this.type}-clone`, "qs-clone");
            this.clone.classList.remove("accordion-quickswitch", "accordion-similar");
            this.insertAdjacentElement("afterend", this.clone);
          }
          if (!this.clone)
            return;
          const items = this.clone.querySelectorAll(".item");
          const itemsReal = this.querySelectorAll(".item");
          let lastVisibleItem = null;
          let lastVisibleItemIndex = 0;
          const lastItemIndex = items.length - 1;
          const lastItem = items[lastItemIndex];
          const lastItemReal = itemsReal[lastItemIndex];
          const firstRowTop = items[0].offsetTop;
          const numberOfRows = new Set([...items].map((item) => item.offsetTop)).size;
          const containerRight = this.scrollLeft + this.clientWidth;
          items.forEach((item, index) => {
            const itemCenter = item.offsetTop + item.offsetWidth / 2;
            if (item.offsetTop > firstRowTop) {
              return;
            }
            if (itemCenter > 0 && itemCenter <= containerRight) {
              lastVisibleItem = item;
              lastVisibleItemIndex = index;
            }
          });
          const lastVisibleItemReal = itemsReal[lastVisibleItemIndex];
          itemsReal.forEach((item) => item.classList.remove("show-more", "last-visible-item"));
          lastVisibleItemReal.classList.add("last-visible-item");
          if (lastVisibleItemIndex != lastItemIndex - 1 || lastItem.classList.contains("has-similar")) {
            if (!lastVisibleItemReal.classList.contains("last-item"))
              lastVisibleItemReal.classList.add("show-more");
          }
          if (window.matchMedia("(max-width: 749px)").matches)
            this.removeAttribute("open");
          this.list.style.height = "";
          this.list.style.overflow = "hidden";
          if (numberOfRows == 1) {
            this.minHeight = this.maxHeight = this.roundUp(this.clone.getBoundingClientRect().height) + "px";
          } else {
            if (lastVisibleItem) {
              this.minHeight = this.roundUp(lastVisibleItem.getBoundingClientRect().height) + "px";
            } else {
              this.minHeight = this.roundUp(items[0].getBoundingClientRect().height) + "px";
            }
            this.maxHeight = this.roundUp(this.clone.getBoundingClientRect().height) + "px";
          }
          this.list.style.height = this.hasAttribute("open") ? this.maxHeight : this.minHeight;
          this.style.setProperty("--container-width", this.getBoundingClientRect().width + "px");
        }
        roundUp(num) {
          return Math.floor(num) + 1;
        }
        init() {
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.addEventListener("click", (e) => this.onClick(e));
          this.list.querySelectorAll(".item").forEach((item) => {
            item.addEventListener("mouseenter", this.onmouseenter.bind(this));
            item.addEventListener("mouseleave", this.onmouseleave.bind(this));
          });
          this.querySelector(".jsToggleQuickSwitchDesktopLabel")?.addEventListener("click", (e) => {
            e.preventDefault();
            const mainCheckbox = document.getElementById("toggleSwitchProduct");
            mainCheckbox.checked = !mainCheckbox.checked;
            e.target.closest(".pdp-quick-switch").classList.toggle("switched", mainCheckbox.checked);
          });
          this.classList.add("quick-switch-images-initialized");
        }
        onmouseenter(e) {
          if (!window.matchMedia("(hover: hover)").matches)
            return;
          e.preventDefault();
          const target = e.target;
          const tooltip = target.querySelector(".item-tooltip");
          if (!tooltip)
            return;
          target.classList.add("show-tooltip");
          tooltip.style.setProperty("--item-left", target.getBoundingClientRect().left + "px");
          tooltip.style.setProperty("--item-top", target.getBoundingClientRect().top + "px");
          tooltip.style.setProperty("--item-width", target.getBoundingClientRect().width + "px");
        }
        onmouseleave(e) {
          if (!window.matchMedia("(hover: hover)").matches)
            return;
          e.preventDefault();
          const target = e.target;
          const tooltip = target.querySelector(".item-tooltip");
          if (!tooltip)
            return;
          target.classList.remove("show-tooltip");
          tooltip.style.removeProperty("--item-left");
          tooltip.style.removeProperty("--item-top");
          tooltip.style.removeProperty("--item-width");
        }
        onClick(e) {
          const target = e.target;
          if (!target.closest(".show-more-btn") && !target.closest(".show-less-btn"))
            return;
          e.preventDefault();
          if (this.isClosing || !this.hasAttribute("open")) {
            this.open();
          } else if (this.isExpanding || this.hasAttribute("open")) {
            this.shrink();
          }
        }
        open() {
          this.list.style.height = this.maxHeight;
          this.setAttribute("open", true);
          this.classList.add("is-opening");
          window.requestAnimationFrame(() => this.expand());
        }
        shrink() {
          this.list.style.height = this.minHeight;
          this.isClosing = true;
          if (this.animation) {
            this.animation.cancel();
          }
          this.classList.add("is-closing");
          this.animation = this.list.animate(
            {
              height: [this.maxHeight, this.minHeight]
            },
            {
              duration: 400,
              easing: "ease-out"
            }
          );
          this.animation.onfinish = () => this.onAnimationFinish(false);
          this.animation.oncancel = () => this.isClosing = false;
        }
        expand() {
          this.isExpanding = true;
          if (this.animation) {
            this.animation.cancel();
          }
          this.animation = this.list.animate(
            {
              height: [this.minHeight, this.maxHeight]
            },
            {
              duration: 400,
              easing: "ease-out"
            }
          );
          this.animation.onfinish = () => this.onAnimationFinish(true);
          this.animation.oncancel = () => this.isExpanding = false;
        }
        onAnimationFinish(open) {
          if (open) {
            this.setAttribute("open", true);
          } else {
            this.removeAttribute("open");
          }
          this.animation = null;
          this.isClosing = false;
          this.isExpanding = false;
          this.classList.remove("is-closing", "is-opening");
          if (open) {
            this.list.style.height = this.maxHeight;
          } else {
            this.list.style.height = this.minHeight;
          }
        }
      }
      customElements.define("quick-switch-images", QuickSwitchImages);
    }
  }
  if (!customElements.get("product-container")) {
    class ProductContainer extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.bindEvents();
        this.saveProductToLocalStorage();
        this.setReviewWidgetDisplay();
        if (!!this.closest("popup-component"))
          return;
        this.trackingScrollRightColumn();
        this.checkUpdateCartButton();
        this.checkUrl();
        this.konfiguratorObj = {
          idInUrl: "",
          eleCustomization: [],
          idCustomization: [],
          currentCustomization: 0
        };
        this.konfiguratorMessageHandler = (message) => {
        };
        this.konfiguratorRenderData = (e) => {
          const { cartItems, trigger, productType, jacketKeys } = e.detail;
          this.renderOptionsPreData(cartItems, trigger, productType, jacketKeys);
        };
        this.konfiguratorResetSelection = async (e) => {
          await this.konfiguratorResetSelectionHandler(e);
        };
        this.konfiguratorRenderProperties = (e) => {
          this.konfiguratorRenderPropertiesHandler(e);
        };
        window.addEventListener("message", this.konfiguratorMessageHandler);
        window.addEventListener("konfigurator:render-data", this.konfiguratorRenderData);
        window.addEventListener("konfigurator:reset-selection", this.konfiguratorResetSelection);
        window.addEventListener("konfigurator:render-properties", this.konfiguratorRenderProperties);
      }
      trackingScrollRightColumn() {
        document.addEventListener("DOMContentLoaded", () => {
          const container = this.querySelector(".block-pdp-info");
          function _trackingScrollRightColumn(eventType) {
            if (window.innerWidth < 750) {
              container.classList.remove("show-bottom-shadow");
              return;
            }
            const isAtBottom = Math.ceil(container.scrollTop + container.clientHeight) >= container.scrollHeight;
            if (isAtBottom) {
              container.classList.remove("show-bottom-shadow");
            } else {
              container.classList.add("show-bottom-shadow");
            }
          }
          container.addEventListener("scroll", (e) => {
            _trackingScrollRightColumn("scroll");
          });
          container.addEventListener("click", (e) => {
            const target = e.target;
            if (target.closest("accordion-component") || target.closest("quick-switch-images")) {
              _trackingScrollRightColumn("click");
            }
          });
          _trackingScrollRightColumn();
        });
      }
      setReviewWidgetDisplay() {
        const reviewWidgetHost = this.querySelectorAll(".gw-rv-average-placeholder");
        if (!reviewWidgetHost.length)
          return;
        reviewWidgetHost.forEach((widget) => {
          const waitForReviewApp = setInterval(() => {
            const shadow = widget.shadowRoot;
            const ratingText = shadow?.querySelector(".gw-rv-average__rating_text");
            if (shadow && ratingText && ratingText.textContent.trim().length > 0) {
              clearInterval(waitForReviewApp);
              if (ratingText && !ratingText.textContent.toLowerCase().includes("no reviews")) {
                widget.classList.add("has-review");
              }
            }
          }, 100);
        });
      }
      checkUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let launch_designer = urlParams.get("launch_designer");
        if (!launch_designer)
          return;
        urlParams.delete("launch_designer");
        const newQuery = urlParams.toString();
        const newUrl = window.location.href.split("?")[0] + (newQuery ? "?" + newQuery : "");
        window.history.replaceState({}, document.title, newUrl);
        const configureButton = document.querySelector(".js-configure");
        if (!configureButton.classList.contains("lding")) {
          configureButton.click();
        } else {
          document.addEventListener("theme:konfigurator_frontend:loaded", () => {
            configureButton.click();
          });
        }
      }
      disconnectedCallback() {
        window.removeEventListener("message", this.konfiguratorMessageHandler);
        window.removeEventListener("konfigurator:render-data", this.konfiguratorRenderData);
        window.removeEventListener("konfigurator:reset-selection", this.konfiguratorResetSelection);
        window.removeEventListener("konfigurator:render-properties", this.konfiguratorRenderProperties);
      }
      konfiguratorRenderPropertiesHandler(e) {
      }
      async konfiguratorResetSelectionHandler(e) {
        e.preventDefault();
        requestAnimationFrame(() => {
          window.location.reload();
        });
      }
      renderOptionsPreData(arrOptions, triggerClickHideShowDetails = true, productType, jacketKeys) {
        let this2 = this;
        let hiddenOptions = [];
        switch (productType.toLowerCase()) {
          case "jacket":
            hiddenOptions = ["fabric", "chest pocket"];
            break;
          case "suit":
            hiddenOptions = ["fabric", "tuxedo"];
            break;
          case "vest":
            hiddenOptions.push("fabric");
            hiddenOptions.push("ticket pocket");
            break;
          case "pants":
            hiddenOptions.push("fabric");
            break;
          default:
            break;
        }
        this2.renderOptions(arrOptions, triggerClickHideShowDetails, hiddenOptions, jacketKeys);
      }
      renderOptions(array, triggerClickHideShowDetails = true, hiddenOptions = [], jacketKeys) {
        let productType = window.theme.product.type.toLowerCase();
        let this2 = this;
        let konDiv = document.querySelector("konfigurator-properties .kon-message");
        let div = document.createElement("div");
        let div2 = document.createElement("div");
        array.forEach((item, index) => {
          let i = item.label.split(":");
          let label = i[0].trim();
          let value = i[i.length - 1].trim();
          if (typeof hiddenOptions === "object" && hiddenOptions.indexOf(label.toLowerCase()) > -1 || value === "undefined") {
            return false;
          }
          if (item.price && item.price.valueUSD && item.price.valueUSD != 0) {
            value = value + " | " + (item.price.valueUSD * 100).toCurrency();
          }
          let line = document.createElement("div");
          line.className = "kon-row";
          line.innerHTML = `<div><span class="kon-label">${label}</span><span class="kon-value">${value}</span></div>`;
          line.setAttribute(`data-${this2.handleText(label)}`, value);
          if (productType == "suit") {
            if (label.toLowerCase() == "pants" && value == "Default selections") {
              div2.appendChild(line);
            } else {
              const isJacketKey = jacketKeys.findIndex((jacketKey) => jacketKey == label.toLowerCase());
              if (isJacketKey != -1) {
                div.appendChild(line);
              } else {
                if (this2.handleText(label) == "tuxedo-stripe" && value.toLowerCase() == "no") {
                  const isTuxedo = document.querySelector("product-container").getAttribute("data-tuxedo");
                  const hasTuxedoSatin = array.find((item2, index2) => {
                    let i2 = item2.label.split(":");
                    let label2 = i2[0].trim();
                    let value2 = i2[i2.length - 1].trim();
                    return this2.handleText(label2) == "tuxedo-satin" && value2 != "";
                  });
                  if (hasTuxedoSatin || isTuxedo == "true") {
                    div2.appendChild(line);
                  }
                } else {
                  div2.appendChild(line);
                }
              }
            }
          } else {
            div.appendChild(line);
          }
        });
        if (!div.innerHTML.trim().length || !konDiv)
          return;
        if (productType == "suit") {
          let konDiv2 = document.querySelector("konfigurator-properties .default-konf-pants .kon-message");
          konDiv.innerHTML = div.innerHTML;
          konDiv2.innerHTML = div2.innerHTML;
        } else {
          konDiv.innerHTML = div.innerHTML;
        }
      }
      handleText(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
      }
      bindEvents() {
        this.addEventListener(
          "click",
          (e) => {
            const { target: el } = e;
            if (el.closest('a[href*="fasterOptions"]')) {
              e.preventDefault();
              this.querySelector("#fasterOptions summary")?.click();
            }
          },
          { passive: false }
        );
        this.querySelector(".js-drawer-open-addons")?.addEventListener("click", (e) => {
          e.stopPropagation();
          window.dispatchEvent(new CustomEvent("addOn:open"));
        });
      }
      /**
       * function to save products to localstorage for recently viewed products function
       */
      saveProductToLocalStorage() {
        let currentProductHandle = theme?.product?.handle || this.dataset.productHandle;
        if (!currentProductHandle)
          return;
        let productHandleArray = JSON.parse(localStorage.getItem("recently-viewed-products")) || [];
        if (productHandleArray.length) {
          !productHandleArray.includes(currentProductHandle) && productHandleArray.unshift(currentProductHandle);
          productHandleArray.length = 10;
        } else {
          productHandleArray.unshift(currentProductHandle);
        }
        localStorage.setItem("recently-viewed-products", JSON.stringify(productHandleArray.filter(Boolean)));
      }
      checkUpdateCartButton(cart) {
        if (!this.getAttribute("data-update-button").includes(this.getAttribute("data-product-type"))) {
          this._isElementInCart = null;
          this._updateButtonHandler = false;
          return;
        }
        this._updateButtonHandler = true;
        let isElementInCart = false;
        if (cart) {
          if (cart.item_count > 0) {
            isElementInCart = cart.items.find((item) => {
              return item.handle == this.getAttribute("data-product-handle");
            });
          }
        } else {
          if (document.querySelectorAll("#cartDrawer .cart-item").length > 0) {
            isElementInCart = [...document.querySelectorAll("#cartDrawer .cart-item")].find((element) => {
              return element.getAttribute("data-product-handle") == this.getAttribute("data-product-handle");
            });
          }
        }
        if (!!isElementInCart) {
          if (!this.classList.contains("update-button")) {
            this.classList.add("update-button");
            this.querySelectorAll("[data-add-to-cart-text]").forEach((item) => {
              item.innerHTML = window.theme.string.updateCart;
            });
            this._isElementInCart = true;
          }
        } else {
          if (this.classList.contains("update-button")) {
            this.classList.remove("update-button");
            this.querySelectorAll("[data-add-to-cart-text]").forEach((item) => {
              item.innerHTML = item.getAttribute("data-add-to-cart-text");
            });
            this._isElementInCart = false;
          }
        }
      }
      /**
       * When the add to cart button has the text update cart,
       * it will not add this product to the cart anymore but only update the product in the cart.
       */
      async updateCartButtonHandler() {
        const productHandle = this.getAttribute("data-product-handle");
        const cart = await window.fetchCartItems();
        if (!cart) {
          const cartDrawer = document.querySelector("cart-component");
          cartDrawer.notify("An error occurred while updating the cart.");
          return;
        }
        const updates = {};
        const getItemExisted = cart.items.filter((item) => {
          return item.handle === productHandle;
        }) || [];
        if (getItemExisted.length) {
          const arraySorted = getItemExisted.sort((a, b) => b.properties?.__timeStamp - a.properties?.__timeStamp);
          arraySorted.forEach((cartItem, index) => {
            let { key } = cartItem;
            updates[key] = index == 0 ? 1 : 0;
          });
        }
        if (Object.keys(updates).length > 0) {
          const cartUpdated = await window.updateCartItems(updates);
          if (!cartUpdated) {
            const cartDrawer = document.querySelector("cart-component");
            cartDrawer.notify("An error occurred while updating the cart.");
            return;
          }
        }
      }
      /**
       * Check and possibly re-render the text of the add to cart button when events like adding and deleting products occur.
       */
      static checkUpdateCartButtonStatic() {
        window.addEventListener("cart:ready", (evt) => {
          const {
            detail: { cart }
          } = evt;
          const productContainerArray = document.querySelectorAll("product-container");
          productContainerArray.forEach((container) => {
            container.checkUpdateCartButton(cart);
          });
        });
      }
      static konfiguratorImageUpdated() {
        window.addEventListener("konfigurator:imageUpdated", (e) => {
          const {
            detail: { src }
          } = e;
          if (!src || typeof src != "object")
            return;
          src.forEach((imgSrc, index) => {
            if (imgSrc) {
              const img = document.createElement("img");
              img.src = imgSrc;
              if (index == 0) {
                document.querySelector(".js-kon-image-summary").innerHTML = "";
                document.querySelector(".js-kon-image").innerHTML = "";
                const imgClone = img.cloneNode(true);
                document.querySelector(".js-kon-image-summary").insertAdjacentElement("beforeend", imgClone);
              }
              document.querySelector(".js-kon-image").insertAdjacentElement("beforeend", img);
            }
          });
        });
      }
    }
    ProductContainer.konfiguratorImageUpdated();
    ProductContainer.checkUpdateCartButtonStatic();
    customElements.define("product-container", ProductContainer);
  }
  if (!customElements.get("pdp-description")) {
    class PDPDescription extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        if (!this.hasAttribute("show_description_learn_more"))
          return;
        this.init();
        this.resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            this.init();
          }
        });
        this.resizeObserver.observe(this);
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
      init() {
        const el = this.querySelector(".display-text");
        const originalTextEl = el.nextElementSibling;
        const originalText = originalTextEl.textContent.trim();
        el.textContent = originalText;
        const words = originalText.split(" ");
        const originalTextElHeight = el.clientHeight;
        const productUrl = this.getAttribute("data-product-url");
        el.textContent = "";
        for (let i = 0; i < words.length; i++) {
          el.textContent = words.slice(0, i + 1).join(" ");
          if (el.scrollHeight > originalTextElHeight) {
            const final = words.slice(0, i - 4).join(" ") + "\u2026 ";
            el.innerHTML = final + `<a class="pdp-desc-learn-more-link" href="${productUrl}">Learn more</a>`;
            break;
          }
        }
      }
    }
    customElements.define("pdp-description", PDPDescription);
  }
  if (!customElements.get("product-cart-form-bcpo")) {
    class productCartFormBCPO extends cartForm {
      constructor() {
        super();
        this.mobileSubmitButton = document.querySelector(".pdp-sticky-component-wrapper .add-to-cart");
        this.form = this.querySelector("form");
        this.bcpoForm = document.querySelector(".best-custom-product-options form");
        this.form.addEventListener("submit", (event) => {
          this.bcpoSubmitFallback(event);
        });
        const waitForBCPO = setInterval(() => {
          if (window.bcpo && window.bcpo.$) {
            const submitButton = this.form.querySelector('button[type="submit"]');
            const configureButton = document.querySelector("#configure");
            if (!configureButton) {
              clearInterval(waitForBCPO);
              submitButton.classList.remove("disabled");
              this.mobileSubmitButton?.classList.remove("disabled");
            } else {
              if (!configureButton.classList.contains("lding")) {
                clearInterval(waitForBCPO);
                submitButton.classList.remove("disabled");
                this.mobileSubmitButton?.classList.remove("disabled");
              } else {
                clearInterval(waitForBCPO);
              }
            }
          }
        }, 50);
        const waitForBCPO2 = setInterval(() => {
          if (window.bcpo && window.bcpo.$) {
            clearInterval(waitForBCPO2);
            this.beforeAddtoCartHandler();
            this.afterAddToCartHandler();
          }
        }, 50);
        this.mobileSubmitButton?.addEventListener("click", () => {
          if (this.bcpoForm && this.bcpoForm.checkValidity()) {
            this.mobileSubmitButtonloadingState = true;
          } else if (!this.bcpoForm) {
            this.mobileSubmitButtonloadingState = true;
          }
          const submitButton = this.form.querySelector('button[type="submit"]');
          submitButton.click();
        });
      }
      connectedCallback() {
      }
      bcpoSubmitFallback(event) {
        event.preventDefault();
        console.log("==-bcpoSubmitFallback");
        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }
        console.log(this.form, "==-this.form");
        const formData = new FormData(this.form);
        formData.append("sections", this.sectionList());
        formData.append("sections_url", this.dataset.url || location.pathname);
        console.log(window.bcpo && window.bcpo.$, "==-window.bcpo && window.bcpo.$");
        if (window.bcpo && window.bcpo.$) {
          const sentBy = "bcpoFallback";
          window.bcpo.$(document).triggerHandler("bcpo:beforeAddToCart", [formData, sentBy]);
        }
        this.postCart("add", formData, () => {
          const sentBy = "bcpoFallback";
          window.bcpo.$(document).triggerHandler("bcpo:afterAdd", [sentBy]);
        });
      }
      beforeAddtoCartHandler() {
        window.bcpo.$(document).on("bcpo:beforeAddToCart", (e, data, sentBy) => {
          console.log("Form data:", Array.from(data.entries()));
          console.log(sentBy, "==-sentBy");
          console.log(sentBy && sentBy != "bcpoFallback", "==-sentBy && sentBy != bcpoFallback");
          if (sentBy && sentBy != "bcpoFallback")
            return;
          const cart = window.bcpo.cart;
          const productContainer = document.querySelector("product-container");
          console.log("cart::", cart);
          if (productContainer && productContainer._updateButtonHandler && productContainer._isElementInCart) {
            const isSelleasyProperty = cart.items.findIndex((item) => item.product_id == window.theme.product.id && item.properties["_lb-product"]);
            if (isSelleasyProperty != -1) {
              const itemInCart = cart.items[isSelleasyProperty];
              data.append(`properties[_lb-product]`, itemInCart.properties["_lb-product"]);
            }
            const isAddOnForProperty = cart.items.findIndex((item) => item.product_id == window.theme.product.id && item.properties["Add On For"]);
            if (isAddOnForProperty != -1) {
              const itemInCart = cart.items[isAddOnForProperty];
              data.append(`properties[Add On For]`, itemInCart.properties["Add On For"]);
            }
          }
          if (!document.querySelector("#configure")) {
            console.log(data, "==-data");
            const productType = window.theme.product.type.toLowerCase();
            if (productType == "suit" || productType == "jacket" || productType == "vest" || productType == "pants" || productType == "shirt" || productType == "coat") {
              let dfData = false;
              let useJacketDefault = false;
              let usePantsDefault = false;
              for (const [key, value] of data.entries()) {
                if ((value.toLowerCase().trim() == "standard selections" || value.toLowerCase().trim().includes("standard")) && key.toLowerCase().trim() == `properties[${window.bcpo_data["virtual_options"][0].title.toLowerCase().trim()}]`) {
                  dfData = useJacketDefault = usePantsDefault = true;
                  break;
                }
              }
              if (productType == "suit") {
                for (const [key, value] of data.entries()) {
                  if ((value.toLowerCase().trim() == "standard selections" || value.toLowerCase().trim().includes("standard")) && (key.toLowerCase().trim() == `properties[jacket]` || key.toLowerCase().trim() == `properties[pants]`)) {
                    dfData = true;
                    if (key.toLowerCase().trim() == `properties[jacket]`) {
                      useJacketDefault = true;
                    } else {
                      usePantsDefault = true;
                    }
                    break;
                  }
                }
              }
              console.log(dfData, "==-dfData");
              if (dfData) {
                if (document.querySelectorAll("#vopoDefaultProperties input").length > 0) {
                  let defaultProps = [];
                  if (productType == "suit") {
                    const jacket_key = "Monogram,Vents,Shoulder,Stitching,Chest Pocket,Canvas,Piping,Cuffs,functional,Ticket Pocket,Side Pockets,Lapels,Buttons,Lining,Tuxedo Satin,Jacket Type,Fabric,Jacket Style,Sleeves,Lining Style,Shoulders,Lapel Buttonhole,Lapel Width,Lapel Type,Functionality";
                    const pants_key = "Waistband,Pleats,Pants Pockets,Rear Pockets,Hem Style,Leg Lining,Tuxedo Stripe,Suspender Buttons,Waistband Height,Dinner Split,Length";
                    defaultProps = [...document.querySelectorAll("#vopoDefaultProperties input")].filter((input) => {
                      const isJacketKey = jacket_key.split(",").find((key) => {
                        return input.name.toLowerCase().includes(key.trim().toLowerCase());
                      });
                      const isPantsKey = pants_key.split(",").find((key) => {
                        return input.name.toLowerCase().includes(key.trim().toLowerCase());
                      });
                      if (isJacketKey || isPantsKey) {
                        if (isJacketKey) {
                          return useJacketDefault ? true : false;
                        } else {
                          return usePantsDefault ? true : false;
                        }
                      }
                      return true;
                    }).map((input) => {
                      return {
                        [input.name]: input.value
                      };
                    });
                  } else {
                    defaultProps = [...document.querySelectorAll("#vopoDefaultProperties input")].map((input) => {
                      return {
                        [input.name]: input.value
                      };
                    });
                  }
                  for (let index = 0; index < defaultProps.length; index++) {
                    const obj = defaultProps[index];
                    const [[key, value]] = Object.entries(obj);
                    data.append(key, value);
                  }
                }
              }
            }
          }
        });
      }
      afterAddToCartHandler() {
        const callback = async (e, sentBy) => {
          console.log("==-afterAddToCartHandler");
          if (sentBy && sentBy != "bcpoFallback")
            return;
          setTimeout(() => {
            document.querySelector(".bcpo-modal-parent .bcpo-modal-close")?.click();
          }, 500);
          const container = this.closest("product-container");
          const submitButton = container.querySelector("product-cart-form-bcpo .add-to-cart");
          const loader = submitButton.querySelector(".r-apps-loader--inside-atc");
          if (container._isElementInCart && container._updateButtonHandler) {
            loader?.classList.remove("r-apps-loader--hidden");
            submitButton.setAttribute("disabled", "disabled");
            await container.updateCartButtonHandler();
            window.addEventListener(
              "cart:ready",
              (evt) => {
                requestAnimationFrame(() => {
                  loader?.classList.add("r-apps-loader--hidden");
                  submitButton.removeAttribute("disabled");
                  if (this.mobileSubmitButton && this.mobileLoading)
                    this.mobileSubmitButtonloadingState = false;
                });
              },
              { once: true }
            );
            document.dispatchEvent(new CustomEvent("cart:build", { detail: { redirectOrOpenDrawer: true } }));
          } else {
            loader?.classList.add("r-apps-loader--hidden");
            submitButton.removeAttribute("disabled");
            if (this.mobileSubmitButton && this.mobileLoading)
              this.mobileSubmitButtonloadingState = false;
            const addOnsDrawer = document.querySelector("#addOnsDrawer");
            if (addOnsDrawer.querySelector(".js-bundle-item-list input:not(:checked)")) {
              const viewCartButton = addOnsDrawer.querySelector(".jsAddOnsClose");
              const checkoutButton = addOnsDrawer.querySelector('.cart-notify [name="checkout"]');
              if (viewCartButton)
                viewCartButton.style.pointerEvents = "none";
              if (checkoutButton)
                checkoutButton.style.pointerEvents = "none";
              window.dispatchEvent(new CustomEvent("addOn:open", { detail: { addClass: true } }));
              window.addEventListener(
                "cart:ready",
                (evt) => {
                  if (viewCartButton)
                    viewCartButton.style.pointerEvents = "auto";
                  if (checkoutButton)
                    checkoutButton.style.pointerEvents = "auto";
                },
                { once: true }
              );
              document.dispatchEvent(new CustomEvent("cart:build"));
            } else {
              document.dispatchEvent(new CustomEvent("cart:build", { detail: { redirectOrOpenDrawer: true } }));
            }
          }
          return true;
        };
        window.bcpo.$(document).on("bcpo:afterAdd", callback);
      }
      set mobileSubmitButtonloadingState(bool) {
        const buttons = document.querySelectorAll(".pdp-sticky-component-wrapper .add-to-cart");
        if (bool) {
          if (!this.mobileLoading) {
            buttons.forEach((button) => {
              button.setAttribute("aria-busy", true);
              button.classList.add("disabled");
              button.HTMLTemp = button.innerHTML;
              if (this.loadingCustomText) {
                button.innerHTML = this.loadingCustomText;
              } else {
                button.innerHTML = document.querySelector("#svg_loading").innerHTML;
              }
            });
            this.mobileLoading = true;
          }
        } else {
          buttons.forEach((button) => {
            button.removeAttribute("aria-busy");
            button.classList.remove("disabled");
            button.innerHTML = button.HTMLTemp;
            button.HTMLTemp = null;
          });
          this.mobileLoading = false;
        }
      }
    }
    customElements.define("product-cart-form-bcpo", productCartFormBCPO);
  }
})();
